
const state = {
  tableData: null, // 表格数据
  groupOptions: []
}

const mutations = {
  // 存放表格数据
  offerTableData: (state, data) => {
    state.tableData = data
  },
  // 设为新组别
  newGroup(state, data) {
    if (state.tableData[data.index].length === 1) {
      return
    }
    state.tableData.push([state.tableData[data.index][data.inx]])
    state.tableData[data.index].splice(data.inx, 1)
  },
  // 改变分组
  changeGroup(state, data) {
    state.tableData[data.e].push(state.tableData[data.index][data.inx]) // 更改分组
    if (state.tableData[data.index].length === 1) { // 判断分组只有一个元素 直接删除该分组
      state.tableData.splice(data.index, 1)
    } else {
      state.tableData[data.index].splice(data.inx, 1)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations
}

